import { PageStates } from '../../../services/SystemNames';
import { BottomMenu } from '../../../components/layout/menus/bottom/BottomMenu';

export default function AllPilotagesBottomMenu({ pageState, onClick }) {

    const items = [
        {
            title: "Losoppdrag",
            icon: "anchor",
            event: PageStates.Default
        },
        {
            title: "Stasjoner",
            icon: "star",
            event: PageStates.PilotStationSelector
        },
    ];
    
    return (
        <BottomMenu
            items={items}
            selectedEvent={pageState}
            onCallback={onSelect}
            />            
    )

    function onSelect(item) {
        onClick(item.event);
    }
}
